import { alpha, CircularProgress, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { IForm } from "form/model"
import { getForm } from "form/tools/common"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { IFormInventory } from "../model"
import { getInventory } from "../tools/common"
import { FormInventoryCpmForecastBar } from "./FormInventoryCpmForecastBar"

interface IFormInventoryCpmForecastProps {
  form: IForm | null
  inventory: IFormInventory | null
  contentWidth: number
}

// 1 = isDisabled, 2 = isMaxBidIncluded
function getDisplayInfo(index: number, maxBid: number | null): [boolean, boolean] {
  if (!maxBid) {
    return [false, false]
  }
  const [minRange, maxRange] =
    index === 0 ? [0, 4] : index === 1 ? [4, 8] : index === 2 ? [8, 12] : [12, Number.MAX_VALUE]
  return [minRange >= maxBid, maxBid >= minRange && maxBid < maxRange]
}

const FormInventoryCpmForecastFn = React.memo(
  ({ form, inventory, contentWidth }: IFormInventoryCpmForecastProps): JSX.Element | null => {
    if (!inventory || !form) {
      return null
    }
    return (
      <FlexBox vertical ai="start" sx={{ position: "relative" }}>
        <FlexBox vertical sx={{ width: "12rem", height: "5rem" }}>
          {inventory.hasRefreshError ? (
            <Typography color="error" align="center" fontSize=".8rem">
              {translate("form.inventory.cpm.forecast.error")}
            </Typography>
          ) : inventory.cpmForecastGroups.length === 0 ? (
            inventory.isRefreshing ? (
              <Typography fontSize=".8rem" align="center" sx={{ color: theme => theme.palette.text.primary2 }}>
                {translate("form.inventory.cpm.forecast.loading")}
              </Typography>
            ) : (
              <Typography fontSize=".8rem" align="center" sx={{ color: theme => theme.palette.text.primary2 }}>
                {translate("form.inventory.cpm.forecast.empty")}
              </Typography>
            )
          ) : (
            <>
              {inventory.cpmForecastGroups.map((g, index) => {
                const percent =
                  inventory.cpmForecastTotalImpressions === 0
                    ? 0
                    : Math.round((g.impressions * 100) / inventory.cpmForecastTotalImpressions)
                const [disabled, isMaxBidIncluded] = getDisplayInfo(index, form.configuration.budget.max_bid)
                return (
                  <FormInventoryCpmForecastBar
                    label={translate(`form.inventory.cpm.forecast.label.${index}`)}
                    percent={percent}
                    disabled={disabled}
                    isMaxBidIncluded={isMaxBidIncluded}
                    key={index}
                  />
                )
              })}
            </>
          )}
        </FlexBox>
        {inventory.isRefreshing && (
          <FlexBox sx={{ position: "absolute", width: "100%", height: "100%", backgroundColor: alpha("#ffffff", 0.8) }}>
            <CircularProgress />
          </FlexBox>
        )}
      </FlexBox>
    )
  }
)

export const FormInventoryCpmForecast = connect(
  (state: IRootState): IFormInventoryCpmForecastProps => ({
    form: state.app.activeContext ? getForm(state) : null,
    inventory: state.app.activeContext ? getInventory(state) : null,
    contentWidth: state.ui.contentWidth
  })
)(FormInventoryCpmForecastFn)
